var delve = function (obj, key, def) {
    var path = key.split ? key.split(".") : key;
    var res = obj;
    for (var i = 0; i < path.length; ++i) {
        res = res ? res[path[i]] : undefined;
    }
    return res === undefined ? def : res;
};
export default delve;
